import React from 'react';

const exported = {
  menu: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <rect
          x="1.5144"
          y="17.5014"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="1.5144"
          y="9.5006"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="1.5144"
          y="1.4998"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="9.5152"
          y="17.5014"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="9.5152"
          y="9.5006"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="9.5152"
          y="1.4998"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="17.516"
          y="17.5014"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="17.516"
          y="9.5006"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="17.516"
          y="1.4998"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
      </g>
    </svg>
  ),

  menuWhite: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <rect
          x="1.5144"
          y="17.5014"
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="1.5144"
          y="9.5006"
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="1.5144"
          y="1.4998"
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="9.5152"
          y="17.5014"
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="9.5152"
          y="9.5006"
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="9.5152"
          y="1.4998"
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="17.516"
          y="17.5014"
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="17.516"
          y="9.5006"
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
        <rect
          x="17.516"
          y="1.4998"
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="5.0003"
          height="5.0003"
        />
      </g>
    </svg>
  ),

  settings: (
    <svg
      version="1.1"
      id="Layer_1"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          style={{ strokeWidth: 0.5 }}
          d={`M11.998,16.6621c-2.563,0-4.6479-2.085-4.6479-4.6475c0-2.563,2.085-4.6479,4.6479-4.6479 \
  c2.5625,0,4.6475,2.085,4.6475,4.6479C16.6455,14.5771,14.5605,16.6621,11.998,16.6621z M11.998,8.3667 \
  c-2.0117,0-3.6479,1.6362-3.6479,3.6479c0,2.0107,1.6362,3.6475,3.6479,3.6475c2.0107,0,3.6475-1.6367,3.6475-3.6475 \
  C15.6455,10.0029,14.0088,8.3667,11.998,8.3667z`}
        />
        <path
          style={{ strokeWidth: 0.5 }}
          d={`M11.9961,23.7129c-0.5317,0-1.0576-0.0361-1.6084-0.1123c-0.2236-0.0303-0.3984-0.207-0.4277-0.4307l-0.3535-2.6992 \
  c-0.6577-0.1846-1.291-0.4473-1.8896-0.7822l-2.1606,1.6602c-0.1787,0.1367-0.4268,0.1387-0.606,0.0029 \
  c-0.8496-0.6416-1.6396-1.4316-2.2847-2.2842c-0.1362-0.1797-0.1353-0.4277,0.002-0.6064l1.6602-2.1592 \
  c-0.3359-0.5986-0.5991-1.2324-0.7852-1.8916l-2.6997-0.3535c-0.2231-0.0293-0.3994-0.2051-0.4302-0.4277 \
  c-0.1479-1.0713-0.1479-2.1572,0-3.229c0.0308-0.2231,0.207-0.3979,0.4302-0.4272l2.6997-0.3535 \
  C3.7285,8.96,3.9917,8.3257,4.3276,7.7271L2.6675,5.5679c-0.1372-0.1787-0.1382-0.4268-0.002-0.6064 \
  c0.644-0.8511,1.4341-1.6406,2.2842-2.2837C5.1289,2.542,5.3774,2.5435,5.5562,2.6802l2.1606,1.6602 \
  c0.5977-0.3345,1.231-0.5967,1.8896-0.7827L9.96,0.8589c0.0293-0.2231,0.2041-0.3994,0.4272-0.4302 \
  c1.105-0.1523,2.1245-0.1514,3.23,0.001c0.2236,0.0308,0.3984,0.207,0.4277,0.4302l0.3535,2.7002 \
  c0.6562,0.186,1.2881,0.4482,1.8857,0.7832l2.1602-1.6602c0.1787-0.1372,0.4277-0.1382,0.6064-0.002 \
  c0.8623,0.6528,1.6318,1.4219,2.2842,2.2852c0.1357,0.1797,0.1348,0.4282-0.002,0.6064l-1.6611,2.1606 \
  c0.334,0.5977,0.5967,1.2295,0.7812,1.8848l2.6992,0.3535c0.2236,0.0288,0.3994,0.2041,0.4307,0.4268 \
  c0.1533,1.1016,0.1533,2.1279,0,3.2314c-0.0303,0.2236-0.207,0.3984-0.4297,0.4277l-2.7002,0.3535 \
  c-0.1846,0.6543-0.4463,1.2861-0.7803,1.8838l1.6602,2.1611c0.1367,0.1787,0.1377,0.4268,0.002,0.6064 \
  c-0.6533,0.8643-1.4229,1.6338-2.2842,2.2852c-0.1787,0.1348-0.4277,0.1367-0.6064-0.002l-2.1602-1.6602 \
  c-0.5977,0.335-1.2295,0.5967-1.8857,0.7832l-0.3535,2.7002c-0.0293,0.2227-0.2041,0.3984-0.4277,0.4297 \
  C13.0635,23.6758,12.5332,23.7129,11.9961,23.7129z M10.9009,22.6562c0.7456,0.0762,1.4595,0.0781,2.2026-0.002l0.3467-2.6494 \
  c0.0273-0.2051,0.1777-0.3721,0.3789-0.4209c0.7871-0.1895,1.5381-0.501,2.2314-0.9268c0.1768-0.1074,0.4014-0.0957,0.5664,0.0303 \
  l2.1191,1.6289c0.5703-0.4648,1.0918-0.9863,1.5576-1.5586l-1.6289-2.1201c-0.126-0.1641-0.1377-0.3887-0.0303-0.5654 \
  c0.4248-0.6953,0.7354-1.4453,0.9238-2.2295c0.0488-0.2021,0.2158-0.3525,0.4209-0.3799l2.6494-0.3467 \
  c0.0781-0.7451,0.0781-1.46,0-2.2036l-2.6484-0.3467c-0.2061-0.0269-0.373-0.1777-0.4219-0.3789 \
  c-0.1885-0.7852-0.499-1.5356-0.9248-2.231c-0.1074-0.1763-0.0957-0.4014,0.0303-0.5654l1.6299-2.1196 \
  c-0.4648-0.5713-0.9873-1.0933-1.5576-1.5581L16.627,5.3413c-0.165,0.1255-0.3896,0.1377-0.5664,0.0298 \
  c-0.6934-0.4253-1.4443-0.7368-2.2314-0.9263c-0.2012-0.0488-0.3516-0.2163-0.3789-0.4214L13.1035,1.374 \
  c-0.7432-0.0776-1.458-0.0786-2.2026-0.0005L10.5542,4.021c-0.0269,0.2051-0.1772,0.373-0.3789,0.4214 \
  C9.3857,4.6318,8.6338,4.9438,7.9399,5.3682C7.7637,5.4766,7.5391,5.4653,7.374,5.3384L5.2549,3.71 \
  C4.689,4.1709,4.1592,4.7007,3.6973,5.2666l1.6284,2.1182c0.1265,0.1641,0.1382,0.3896,0.0298,0.5664 \
  C4.9292,8.6455,4.6167,9.3979,4.4272,10.188c-0.0483,0.2017-0.2163,0.3521-0.4214,0.3789l-2.6479,0.3467 \
  c-0.0752,0.7324-0.0752,1.4702,0,2.2017l2.6479,0.3467c0.2056,0.0273,0.373,0.1777,0.4214,0.3789 \
  c0.1895,0.79,0.502,1.542,0.9282,2.2373c0.1084,0.1768,0.0962,0.4023-0.0298,0.5664l-1.6284,2.1182 \
  c0.4624,0.5664,0.9922,1.0957,1.5571,1.5566l2.1196-1.6289c0.165-0.125,0.3896-0.1367,0.5659-0.0303 \
  c0.6953,0.4258,1.4473,0.7373,2.2349,0.9258c0.2017,0.0479,0.3525,0.2158,0.3794,0.4219L10.9009,22.6562z`}
        />
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),

  tray: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M23.501,14.0527c-0.1406,0-0.2803-0.0586-0.3789-0.1738l-4.1875-4.8677H5.0659l-4.1875,4.8677 \
  c-0.1807,0.21-0.4961,0.2314-0.7051,0.0527c-0.2095-0.1797-0.2329-0.4961-0.0527-0.7051l4.3369-5.0415 \
  c0.0947-0.1104,0.2334-0.1738,0.3789-0.1738h14.3276c0.1455,0,0.2842,0.0635,0.3789,0.1738l4.3369,5.0415 \
  c0.1807,0.209,0.1562,0.5254-0.0527,0.7051C23.7324,14.0127,23.6162,14.0527,23.501,14.0527z`}
        />
        <path
          d={`M21.6426,24.0127H2.3579c-1.3003,0-2.3584-1.0576-2.3584-2.3584v-8.1016c0-0.2764,0.2236-0.5,0.5-0.5h7.0659 \
  c0.2764,0,0.5,0.2236,0.5,0.5v2.291c0,0.6514,0.5293,1.1807,1.1802,1.1807h5.5601c0.6514,0,1.1807-0.5293,1.1807-1.1807v-2.291 \
  c0-0.2764,0.2236-0.5,0.5-0.5h7.0146c0.2764,0,0.5,0.2236,0.5,0.5v8.1016C24.001,22.9551,22.9434,24.0127,21.6426,24.0127z \
  M0.9995,14.0527v7.6016c0,0.749,0.6094,1.3584,1.3584,1.3584h19.2847c0.749,0,1.3584-0.6094,1.3584-1.3584v-7.6016h-6.0146v1.791 \
  c0,1.2021-0.9785,2.1807-2.1807,2.1807H9.2456c-1.2021,0-2.1802-0.9785-2.1802-2.1807v-1.791H0.9995z`}
        />
      </g>
      <rect y="0.0001" fill="none" width="24" height="24" />
    </svg>
  ),

  add: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M11.9971,23.8848c-6.5518,0-11.8823-5.3301-11.8823-11.8818c0-6.5522,5.3306-11.8828,11.8823-11.8828 \
  s11.8818,5.3306,11.8818,11.8828C23.8789,18.5547,18.5488,23.8848,11.9971,23.8848z M11.9971,1.1201 \
  c-6.0005,0-10.8823,4.8818-10.8823,10.8828c0,6,4.8818,10.8818,10.8823,10.8818c6,0,10.8818-4.8818,10.8818-10.8818 \
  C22.8789,6.002,17.9971,1.1201,11.9971,1.1201z`}
        />
        <path
          d={`M11.999,19.1025c-0.2764,0-0.5-0.2236-0.5-0.5V5.4023c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5v13.2002 \
  C12.499,18.8789,12.2754,19.1025,11.999,19.1025z`}
        />
        <path
          d={`M18.5986,12.5029H5.3989c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5h13.1997c0.2764,0,0.5,0.2236,0.5,0.5 \
  S18.875,12.5029,18.5986,12.5029z`}
        />
      </g>
    </svg>
  ),

  more: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <circle
        style={{ strokeWidth: 0.7 }}
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        cx="12"
        cy="4"
        r="2.5"
      />
      <circle
        style={{ strokeWidth: 0.7 }}
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        cx="12"
        cy="12"
        r="2.5"
      />
      <circle
        style={{ strokeWidth: 0.7 }}
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        cx="12"
        cy="20"
        r="2.5"
      />
    </svg>
  ),

  whiteAdd: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      background="new 0 0 24 24"
    >
      <g>
        <path
          fill="#ffffff"
          d={`M11.9971,23.8848c-6.5518,0-11.8823-5.3301-11.8823-11.8818c0-6.5522,5.3306-11.8828,11.8823-11.8828 \
  s11.8818,5.3306,11.8818,11.8828C23.8789,18.5547,18.5488,23.8848,11.9971,23.8848z M11.9971,1.1201 \
  c-6.0005,0-10.8823,4.8818-10.8823,10.8828c0,6,4.8818,10.8818,10.8823,10.8818c6,0,10.8818-4.8818,10.8818-10.8818 \
  C22.8789,6.002,17.9971,1.1201,11.9971,1.1201z`}
        />
        <path
          fill="#ffffff"
          d={`M11.999,19.1025c-0.2764,0-0.5-0.2236-0.5-0.5V5.4023c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5v13.2002 \
  C12.499,18.8789,12.2754,19.1025,11.999,19.1025z`}
        />
        <path
          fill="#ffffff"
          d={`M18.5986,12.5029H5.3989c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5h13.1997c0.2764,0,0.5,0.2236,0.5,0.5 \
  S18.875,12.5029,18.5986,12.5029z`}
        />
      </g>
      <rect y="0.001" fill="none" width="24" height="24" />
    </svg>
  ),

  x: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M23.2141,17.9425 \
  l-6.0098-6.0089l5.9762-5.9766c0.2397-0.2397,0.2401-0.6304,0-0.8697l-4.3193-4.3197c-0.2303-0.2303-0.6385-0.2303-0.8692,0 \
  l-5.9766,5.9771L6.0379,0.7676c-0.2312-0.2303-0.6389-0.2303-0.8701,0L0.7831,5.1541c-0.2393,0.2402-0.2393,0.6291,0,0.8697 \
  l5.9766,5.9762l-5.9425,5.9439c-0.2411,0.2397-0.2411,0.6291,0,0.8688l4.3184,4.3188c0.2401,0.2397,0.6286,0.2397,0.8688,0 \
  l5.9439-5.943l6.0107,6.0102c0.2377,0.2394,0.6301,0.24,0.8692,0l4.386-4.3865C23.4526,18.5755,23.4558,18.1842,23.2141,17.9425z`}
        />
      </g>
    </svg>
  ),

  info: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M11.9853,0.5656 \
  c-6.2977,0-11.4207,5.123-11.4207,11.4207s5.1231,11.4216,11.4207,11.4216s11.4207-5.1239,11.4207-11.4216 \
  S18.2829,0.5656,11.9853,0.5656z`}
        />
        <circle
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="11.9882"
          cy="5.9996"
          r="2.4773"
        />
        <path
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M15.5011,19.4855 \
  H9.4285c-1.1184,0-1.0773-1.9414,0-1.9414h1.2004v-5.1327H9.4285c-1.1096,0-1.0859-1.9414,0-1.9414h4.8408 \
  c0.1638,0,0.2971,0.1348,0.2971,0.3004v6.7738h0.9347C16.5781,17.5441,16.616,19.4855,15.5011,19.4855z`}
        />
      </g>
      <rect x="-0.0137" y="0.0002" fill="none" width="24" height="24" />
    </svg>
  ),

  print: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <line
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="8.5"
          y1="20.5"
          x2="15.4"
          y2="20.5"
        />
        <line
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="8.5"
          y1="18.5"
          x2="15.4"
          y2="18.5"
        />
        <line
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="17.5"
          y1="7.6"
          x2="6.5"
          y2="7.6"
        />
        <path
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M6.5,3.5h-4 \
  c-1.1,0-2,0.9-2,2v6.9c0,1.1,0.9,2,2,2h19c1.1,0,2-0.9,2-2V5.5c0-1.1-0.9-2-2-2h-4`}
        />
        <path
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M6.5,16.6V23 \
  c0,0.3,0.2,0.5,0.5,0.5h10c0.3,0,0.5-0.2,0.5-0.5v-6.4`}
        />
        <path
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M17.5,7.6V3.7 \
  c0-0.1-0.1-0.3-0.2-0.4l-2.1-2.6c-0.1-0.1-0.2-0.1-0.4-0.1H7c-0.3,0-0.5,0.2-0.5,0.5v6.5`}
        />
        <line
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="20.4"
          y1="11.5"
          x2="20.5"
          y2="11.5"
        />
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),

  email: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <polyline
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          points={`18.5,10.5 23.5,10.4864 23.5,23.5 \
  0.5,23.5 0.5,10.4864 5.5,10.4864  `}
        />
        <path
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M5.5,13.4678V4.0332 \
  C5.5,3.7166,5.7453,3.5,6.0621,3.5h9.5133c0.1507,0,0.2952,0.0391,0.4023,0.1448l2.3774,2.359 \
  C18.4641,6.1114,18.5,6.2485,18.5,6.4019v7.0659`}
        />
        <path
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M8.5,6.5v3.025 \
  c0,1.0616,0.9384,1.9229,2.0002,1.9228C11.5619,11.4476,12.5,10.5866,12.5,9.525V2.0928c0-0.7961-0.7036-1.4419-1.4998-1.4421 \
  C10.2034,0.6507,9.5,1.2969,9.5,2.0932V3.5`}
        />
        <polyline
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points={`\
  15.4924,3.5 15.4924,6.5 18.5,6.5  `}
        />
        <polyline
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          points={`0.5,10.4864 11.9811,17.39 \
  23.5,10.4864  `}
        />
      </g>
      <rect x="0" y="0" fill="none" width="24" height="24" />
    </svg>
  ),

  documents: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <polyline
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points={`\
  16.9729,0.5001 16.9729,3.9915 20.5095,3.9915  `}
        />
        <path
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M20.5095,19.8773 \
  c0,0.3811-0.313,0.6982-0.6998,0.6982H6.1748c-0.386,0-0.696-0.3171-0.696-0.6982V1.2032c0-0.3809,0.31-0.7031,0.696-0.7031h10.798 \
  c0.1836,0,0.2689,0.078,0.3994,0.205l2.9287,2.853c0.1329,0.1294,0.2086,0.3098,0.2086,0.4943V19.8773z`}
        />
        <line
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="17"
          y1="16.5002"
          x2="9"
          y2="16.5002"
        />
        <line
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="17"
          y1="13.5002"
          x2="9"
          y2="13.5002"
        />
        <line
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="17"
          y1="10.5001"
          x2="9"
          y2="10.5001"
        />
        <line
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="14"
          y1="7.5001"
          x2="9"
          y2="7.5001"
        />
        <path
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M3.2194,3.4804 \
  c-0.4012,0-0.7258,0.3246-0.7258,0.725v18.5938c0,0.4008,0.3246,0.7258,0.7258,0.7258h14.5948c0.4004,0,0.7254-0.325,0.7254-0.7258\
  `}
        />
      </g>
    </svg>
  ),

  tick: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <circle
          fill="none"
          stroke="#009933"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="12.0115"
          cy="12.0025"
          r="11.3822"
        />
        <polyline
          fill="none"
          stroke="#009933"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="7.0738,12.345 10.3922,16.4938 17.5378,7.5602   "
        />
      </g>
      <rect x="0" y="0.001" fill="none" width="24" height="24" />
    </svg>
  ),

  taskTick: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <circle
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="12.0115"
          cy="12.0025"
          r="11.3822"
        />
        <polyline
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="7.0738,12.345 10.3922,16.4938 17.5378,7.5602   "
        />
      </g>
      <rect x="0" y="0.001" fill="none" width="24" height="24" />
    </svg>
  ),

  taskReset: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <polyline
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points={`\
  18.1307,14.8082 21.2879,12.8696 23.2612,16.0835 	`}
        />
        <path
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M21.2879,12.8696 \
  c-0.4415,5.1864-4.9809,8.987-10.1671,8.5453c-5.1864-0.4415-9.0325-5.004-8.591-10.1901c0.4415-5.1862,5.0036-9.0325,10.19-8.591 \
  c2.5459,0.2169,4.7686,1.4262,6.3201,3.2149`}
        />
      </g>
    </svg>
  ),

  cancel: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <line
          fill="none"
          stroke="#FF1919"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="16.6292"
          y1="7.3818"
          x2="7.3878"
          y2="16.6232"
        />
        <line
          fill="none"
          stroke="#FF1919"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="7.3878"
          y1="7.3818"
          x2="16.6292"
          y2="16.6232"
        />
        <circle
          fill="none"
          stroke="#FF1919"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="12.0067"
          cy="12.0025"
          r="11.3822"
        />
      </g>
      <rect x="0" y="0.001" fill="none" width="24" height="24" />
    </svg>
  ),

  customCancel: (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 24 24">
      <g>
        <circle
          fill="#999999"
          stroke="#999999"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="12.0067"
          cy="12.0025"
          r="11.3822"
        />
        <line
          fill="#ffffff"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="16.6292"
          y1="7.3818"
          x2="7.3878"
          y2="16.6232"
        />
        <line
          fill="#ffffff"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="7.3878"
          y1="7.3818"
          x2="16.6292"
          y2="16.6232"
        />
      </g>
    </svg>
  ),

  filter: (
    <svg
      version="1.1"
      id="Layer_1"
      x="2px"
      y="2px"
      width={20}
      height={20}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d={`M22.017,3.1408 \
c0,1.3512-4.4848,2.4465-10.017,2.4465S1.983,4.4919,1.983,3.1408`}
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d={`M22.017,3.1407 \
c0-1.3511-4.4848-2.4465-10.017-2.4465c-5.5322,0-10.017,1.0953-10.017,2.4465c0,0.1644,0.0675,0.3248,0.194,0.48L2.1759,3.6209 \
l7.456,11.3938v8.2143l4.7699-3.3329v-4.8815l7.4219-11.3938l-0.0007,0C21.9495,3.4656,22.017,3.3051,22.017,3.1407z`}
      />
    </svg>
  ),

  notes: (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M20.503,2.865 \
  c0-1.3062-1.059-2.365-2.3652-2.365H5.8683C4.562,0.5,3.503,1.5589,3.503,2.865v18.27c0,1.3062,1.059,2.365,2.3652,2.365h12.2695 \
  c1.3063,0,2.3652-1.0589,2.3652-2.365V2.865z`}
        />
        <line
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="16.4808"
          y1="6.5"
          x2="10.5246"
          y2="6.5"
        />
        <line
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="14.4748"
          y1="8.4998"
          x2="10.5244"
          y2="8.4998"
        />
        <line
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="7.501"
          y1="0.5"
          x2="7.501"
          y2="23.5"
        />
      </g>
    </svg>
  ),

  alert: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="none"
          stroke="#660000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M23.155,18.7765 \
  L14.1541,2.9188c-0.9435-1.6628-3.3481-1.6653-4.293,0L0.8607,18.7765c-0.9332,1.6431,0.2581,3.6866,2.1464,3.6866h18.001 \
  C22.8973,22.4631,24.0871,20.4193,23.155,18.7765z`}
        />
        <line
          fill="none"
          stroke="#660000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="12.008"
          y1="7.8058"
          x2="12.008"
          y2="14.9869"
        />
        <line
          fill="none"
          stroke="#660000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="12.008"
          y1="18.1216"
          x2="12.0077"
          y2="18.3708"
        />
      </g>
    </svg>
  ),

  lock: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M5.5735,9.5 \
    c-1.1754,0-2.132,0.9193-2.132,2.0947l0.9433,9.8071c0,1.1768,0.9567,2.0982,2.132,2.0982h10.9366 \
    c1.1754,0,2.1325-0.9403,2.1325-2.1171l0.9433-9.7963c0-1.1754-0.9571-2.0866-2.1325-2.0866H5.5735z`}
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M13.1013,19.5 \
    h-2.2315l-0.42-3.457c0-0.8331,0.6876-1.4923,1.5342-1.4923c0.848,0,1.5361,0.6507,1.5361,1.4837L13.1013,19.5z`}
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M7.4864,9.5V5.0366 \
    c0-2.3171,2.1268-4.2024,4.5003-4.2024c2.3748,0,4.4997,1.8853,4.4997,4.2024V9.5`}
        />
      </g>
    </svg>
  ),

  whiteLock: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M5.5735,9.5 \
    c-1.1754,0-2.132,0.9193-2.132,2.0947l0.9433,9.8071c0,1.1768,0.9567,2.0982,2.132,2.0982h10.9366 \
    c1.1754,0,2.1325-0.9403,2.1325-2.1171l0.9433-9.7963c0-1.1754-0.9571-2.0866-2.1325-2.0866H5.5735z`}
        />
        <path
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M13.1013,19.5 \
    h-2.2315l-0.42-3.457c0-0.8331,0.6876-1.4923,1.5342-1.4923c0.848,0,1.5361,0.6507,1.5361,1.4837L13.1013,19.5z`}
        />
        <path
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M7.4864,9.5V5.0366 \
    c0-2.3171,2.1268-4.2024,4.5003-4.2024c2.3748,0,4.4997,1.8853,4.4997,4.2024V9.5`}
        />
      </g>
    </svg>
  ),

  greenLock: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="none"
          stroke="#8bc34a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M5.5735,9.5 \
    c-1.1754,0-2.132,0.9193-2.132,2.0947l0.9433,9.8071c0,1.1768,0.9567,2.0982,2.132,2.0982h10.9366 \
    c1.1754,0,2.1325-0.9403,2.1325-2.1171l0.9433-9.7963c0-1.1754-0.9571-2.0866-2.1325-2.0866H5.5735z`}
        />
        <path
          fill="none"
          stroke="#8bc34a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M13.1013,19.5 \
    h-2.2315l-0.42-3.457c0-0.8331,0.6876-1.4923,1.5342-1.4923c0.848,0,1.5361,0.6507,1.5361,1.4837L13.1013,19.5z`}
        />
        <path
          fill="none"
          stroke="#8bc34a"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M7.4864,9.5V5.0366 \
    c0-2.3171,2.1268-4.2024,4.5003-4.2024c2.3748,0,4.4997,1.8853,4.4997,4.2024V9.5`}
        />
      </g>
    </svg>
  ),

  down: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="-8px"
      width="40"
      height="30px"
      viewBox="0 0 40 30"
      enableBackground="new 0 0 30 30"
    >
      <g transform="rotate(90, 15, 15) scale(1.5)">
        <g>
          <path
            d={`M10.3022,17.5127L10.3022,17.5127c-0.7158,0-1.2979-0.5811-1.2979-1.2959L9.0039,7.7764 \
    c0-0.7148,0.5825-1.2964,1.2983-1.2964c0.2881,0,0.5625,0.0952,0.7935,0.2759l5.4062,4.2197C16.8184,11.2227,17,11.5947,17,11.9966 \
    s-0.1816,0.7729-0.498,1.02l-5.4062,4.2207C10.8652,17.417,10.5908,17.5127,10.3022,17.5127z M10.3022,7.48 \
    c-0.124,0-0.2983,0.0918-0.2983,0.2964l0.0005,8.4404c0,0.2041,0.1743,0.2959,0.2979,0.2959l0,0 \
    c0.064,0,0.1235-0.0215,0.1777-0.0635l5.4067-4.2217C15.9854,12.1514,16,12.0498,16,11.9961s-0.0146-0.1553-0.1133-0.2324 \
    L10.48,7.5439C10.4253,7.5015,10.3657,7.48,10.3022,7.48z`}
            style={{
              'stroke: #1D65FF; strokeWidth: 2px; fill:#1D65FF':
                'stroke: #1D65FF; strokeWidth: 2px; fill:#1D65FF'
            }}
          />
        </g>
      </g>
      <rect y="0.001" fill="none" width="40" height="30" />
    </svg>
  ),

  up: (
    <svg
      version="1.1"
      id="Layer_1"
      x="-5px"
      y="0px"
      width="40"
      height="30px"
      viewBox="0 0 40 30"
      enableBackground="new 0 0 30 30"
    >
      <g transform="rotate(270, 15, 15) scale(1.5)">
        <g>
          <path
            d={`M10.3022,17.5127L10.3022,17.5127c-0.7158,0-1.2979-0.5811-1.2979-1.2959L9.0039,7.7764 \
    c0-0.7148,0.5825-1.2964,1.2983-1.2964c0.2881,0,0.5625,0.0952,0.7935,0.2759l5.4062,4.2197C16.8184,11.2227,17,11.5947,17,11.9966 \
    s-0.1816,0.7729-0.498,1.02l-5.4062,4.2207C10.8652,17.417,10.5908,17.5127,10.3022,17.5127z M10.3022,7.48 \
    c-0.124,0-0.2983,0.0918-0.2983,0.2964l0.0005,8.4404c0,0.2041,0.1743,0.2959,0.2979,0.2959l0,0 \
    c0.064,0,0.1235-0.0215,0.1777-0.0635l5.4067-4.2217C15.9854,12.1514,16,12.0498,16,11.9961s-0.0146-0.1553-0.1133-0.2324 \
    L10.48,7.5439C10.4253,7.5015,10.3657,7.48,10.3022,7.48z`}
            style={{
              'stroke: #EC49E9; strokeWidth: 2px; fill:#EC49E9':
                'stroke: #EC49E9; strokeWidth: 2px; fill:#EC49E9'
            }}
          />
        </g>
      </g>
      <rect y="0.001" fill="none" width="40" height="30" />
    </svg>
  ),

  save: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M23.4922,24.0322H0.5054c-0.2764,0-0.5-0.2236-0.5-0.5V0.5454c0-0.2764,0.2236-0.5,0.5-0.5h18.6138 \
    c0.1328,0,0.2598,0.0527,0.3535,0.1465l4.373,4.373c0.0938,0.0938,0.1465,0.2207,0.1465,0.3535v18.6138 \
    C23.9922,23.8086,23.7686,24.0322,23.4922,24.0322z M1.0054,23.0322h21.9868V5.1255l-4.0801-4.0801H1.0054V23.0322z`}
        />
        <path
          d={`M19.5234,24.0322H4.4736c-0.2764,0-0.5-0.2236-0.5-0.5V10.4917c0-0.2764,0.2236-0.5,0.5-0.5h15.0498 \
    c0.2764,0,0.5,0.2236,0.5,0.5v13.0405C20.0234,23.8086,19.7998,24.0322,19.5234,24.0322z M4.9736,23.0322h14.0498V10.9917H4.9736 \
    V23.0322z`}
        />
        <path
          d={`M16.5273,7.9697H7.4702c-0.2764,0-0.5-0.2236-0.5-0.5V0.5454c0-0.2764,0.2236-0.5,0.5-0.5h9.0571 \
    c0.2764,0,0.5,0.2236,0.5,0.5v6.9243C17.0273,7.7461,16.8037,7.9697,16.5273,7.9697z M7.9702,6.9697h8.0571V1.0454H7.9702V6.9697z`}
        />
        <path
          d={`M14.5176,5.9707h-1.125c-0.2764,0-0.5-0.2236-0.5-0.5v-3.123c0-0.2764,0.2236-0.5,0.5-0.5h1.125 \
    c0.2764,0,0.5,0.2236,0.5,0.5v3.123C15.0176,5.7471,14.7939,5.9707,14.5176,5.9707z M13.8926,4.9707h0.125v-2.123h-0.125V4.9707z`}
        />
        <path
          d={`M16.3916,20.0078H7.606c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5h8.7856c0.2764,0,0.5,0.2236,0.5,0.5 \
    S16.668,20.0078,16.3916,20.0078z`}
        />
        <path
          d={`M16.3916,17.0078H7.606c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5h8.7856c0.2764,0,0.5,0.2236,0.5,0.5 \
    S16.668,17.0078,16.3916,17.0078z`}
        />
        <path
          d={`M16.3916,14.0068H7.606c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5h8.7856c0.2764,0,0.5,0.2236,0.5,0.5 \
    S16.668,14.0068,16.3916,14.0068z`}
        />
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),

  go: (
    <svg x="0px" y="0px" width="24px" height="24px">
      <circle
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        cx="12.0307"
        cy="12.0025"
        r="11.3822"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        d={`M16.1941,11.3694l-5.4063-4.2197 \
  c-0.5219-0.4073-1.2838-0.0354-1.2838,0.6266l0.0003,8.4405c0,0.6621,0.7621,1.0339,1.2839,0.6264l5.406-4.2208 \
  C16.6018,12.3042,16.6017,11.6876,16.1941,11.3694z`}
      />
    </svg>
  ),

  back: (
    <svg width={24} height={24} viewBox="0 0 24 24" className="morph-arrow">
      <g transform="rotate(0, 12, 12)">
        <path fill="white" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
      </g>
    </svg>
  ),

  person: (
    <svg version="1.1" x="0px" y="0px" width="24px" height="24px">
      <g>
        <path
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M22.9753,19.01 \
  c-3.7028-1.4309-7.8134-3.2077-8.1588-4.315v-1.1615c0.7681-0.7858,1.374-1.8817,1.7325-3.1648 \
  c0.8551-0.6004,1.0797-1.8468,0.3626-2.729V5.0397c0-2.6842-1.4947-4.5216-4.9118-4.5216c-3.3289,0-4.9135,1.8374-4.9135,4.5216 \
  v2.601c-0.7145,0.8796-0.4925,2.1257,0.3626,2.7276c0.3585,1.2835,0.9648,2.3794,1.7334,3.1652v1.1615 \
  c-0.3445,1.1059-4.456,2.8831-8.1588,4.315c-0.3156,0.1225-0.5244,0.4295-0.5244,0.7726v2.9049 \
  c0,0.4562,0.3648,0.8269,0.8147,0.8269H22.685c0.4499,0,0.8147-0.3707,0.8147-0.8269v-2.9049 \
  C23.4998,19.4395,23.2909,19.1316,22.9753,19.01z`}
        />
      </g>
    </svg>
  ),

  star: (
    <svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24">
      <g>
        <path
          style={{ strokeWidth: 0.7 }}
          fill="#F4D00C"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M22.6795,8.9495 \
  L15.1431,8.797l-2.4741-7.0408c-0.2133-0.6074-1.0709-0.6027-1.2815,0L8.9139,8.797L1.3767,8.9495 \
  C0.7333,8.9633,0.4676,9.7829,0.9834,10.172l6.0013,4.5024l-2.1805,7.1295c-0.1893,0.616,0.5091,1.1224,1.0347,0.7587 \
  l6.1895-4.2617l6.19,4.2617c0.5289,0.3631,1.2233-0.1457,1.0342-0.7587l-2.1818-7.1295l6.0017-4.5024 \
  C23.5886,9.7836,23.3225,8.9633,22.6795,8.9495z`}
        />
      </g>
      <rect x="0.0293" y="-0.0001" fill="none" width="24" height="24" />
    </svg>
  ),

  openStar: (
    <svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24">
      <g>
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M22.6795,8.9495 \
  L15.1431,8.797l-2.4741-7.0408c-0.2133-0.6074-1.0709-0.6027-1.2815,0L8.9139,8.797L1.3767,8.9495 \
  C0.7333,8.9633,0.4676,9.7829,0.9834,10.172l6.0013,4.5024l-2.1805,7.1295c-0.1893,0.616,0.5091,1.1224,1.0347,0.7587 \
  l6.1895-4.2617l6.19,4.2617c0.5289,0.3631,1.2233-0.1457,1.0342-0.7587l-2.1818-7.1295l6.0017-4.5024 \
  C23.5886,9.7836,23.3225,8.9633,22.6795,8.9495z`}
        />
      </g>
      <rect x="0.0293" y="-0.0001" fill="none" width="24" height="24" />
    </svg>
  ),

  location: (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <polygon
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          points={`1.4827,2.9509 14.5,1.0056 \
  14.5,23.5 1.4827,23.5   `}
        />
        <rect
          style={{ strokeWidth: 0.7 }}
          x="6.4515"
          y="18.5436"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          width="2.9895"
          height="4.9375"
        />
        <rect
          style={{ strokeWidth: 0.7 }}
          x="6.4515"
          y="12.4815"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          width="2.9895"
          height="3.0089"
        />
        <rect
          style={{ strokeWidth: 0.7 }}
          x="6.4515"
          y="6.4809"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          width="2.9895"
          height="3.0089"
        />
        <polygon
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          points={`14.5,8.8993 22.5,10.5654 \
  22.5,23.5 14.5,23.5   `}
        />
        <line
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="18.4553"
          y1="23.4811"
          x2="18.4553"
          y2="20.517"
        />
        <line
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="18.4553"
          y1="17.4688"
          x2="18.4553"
          y2="16.3884"
        />
        <line
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="18.4553"
          y1="14.4685"
          x2="18.4553"
          y2="13.3881"
        />
      </g>
      <rect x="0" y="0" fill="none" width="24" height="24" />
    </svg>
  ),

  providerCode: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <polyline
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points={`\
  13.5044,0.5097 13.5044,4.5097 17.5044,4.5097  `}
        />
        <polyline
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points={`\
  4.4388,8.6382 5.5521,8.0941 5.5521,12.1129  `}
        />
        <polyline
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points={`\
  9.7743,15.1414 10.7876,14.7979 10.7876,19.0094   `}
        />
        <ellipse
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="10.0277"
          cy="9.8213"
          rx="1.4599"
          ry="2.0223"
        />
        <ellipse
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="6.0079"
          cy="16.5215"
          rx="1.4599"
          ry="2.0187"
        />
        <path
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M17.5044,21.5229 \
  v1.187c0,0.4366-0.354,0.7999-0.7915,0.7999H1.2917c-0.4366,0-0.7872-0.3633-0.7872-0.7999V1.3153 \
  c0-0.4364,0.3506-0.8056,0.7872-0.8056h12.2127c0.2076,0,0.3041,0.0894,0.4517,0.2349l3.3124,3.2687 \
  c0.1503,0.1483,0.2359,0.285,0.2359,0.4964l0,2.0641`}
        />
        <path
          style={{ strokeWidth: 0.7 }}
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M23.2984,17.44 \
  c-1.6216-0.6647-3.4217-1.49-3.573-2.0043v-0.5395c0.3364-0.365,0.6017-0.8741,0.7587-1.4701 \
  c0.3767-0.2805,0.4714-0.8598,0.1588-1.2676v-1.2078c0-1.2468-0.6546-2.1003-2.151-2.1003c-1.4578,0-2.1518,0.8535-2.1518,2.1003 \
  v1.2082c-0.3121,0.4075-0.2171,0.9863,0.1588,1.267c0.157,0.5962,0.4225,1.1053,0.7591,1.4703v0.5395 \
  c-0.1509,0.5137-1.9514,1.3392-3.573,2.0043c-0.1382,0.0569-0.2297,0.1995-0.2297,0.3589v1.3493 \
  c0,0.2119,0.1598,0.3841,0.3568,0.3841h9.3591c0.197,0,0.3568-0.1722,0.3568-0.3841v-1.3493 \
  C23.5281,17.6395,23.4366,17.4965,23.2984,17.44z`}
        />
      </g>
      <rect x="0" y="0.0001" fill="none" width="24" height="24" />
    </svg>
  ),

  blankCalendar: (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="none"
          stroke="#000000"
          style={{ strokeWidth: 0.5 }}
          strokeMiterlimit="10"
          d={`M21.1079,0.5H2.7373C1.4125,0.5,0.5,1.4385,0.5,2.7647v18.4302 \
  C0.5,22.5208,1.4125,23.5,2.7373,23.5h18.3706c1.3249,0,2.3921-0.9792,2.3921-2.3052V2.7647C23.5,1.4385,22.4328,0.5,21.1079,0.5z`}
        />
        <line
          fill="none"
          style={{ strokeWidth: 0.5 }}
          stroke="#000000"
          strokeMiterlimit="10"
          x1="0.5"
          y1="7.5"
          x2="23.5"
          y2="7.5"
        />
        <line
          fill="none"
          style={{ strokeWidth: 0.5 }}
          stroke="#000000"
          x1="4.5"
          y1="7.4522"
          x2="4.5"
          y2="23.5"
        />
        <line
          fill="none"
          style={{ strokeWidth: 0.5 }}
          stroke="#000000"
          x1="9.5"
          y1="7.4522"
          x2="9.5"
          y2="23.5"
        />
        <line
          fill="none"
          style={{ strokeWidth: 0.5 }}
          stroke="#000000"
          x1="14.5"
          y1="7.4522"
          x2="14.5"
          y2="23.5"
        />
        <line
          fill="none"
          style={{ strokeWidth: 0.5 }}
          stroke="#000000"
          x1="19.5"
          y1="7.4522"
          x2="19.5"
          y2="23.5"
        />
        <line
          fill="none"
          style={{ strokeWidth: 0.5 }}
          stroke="#000000"
          x1="0.5"
          y1="19.5"
          x2="23.5"
          y2="19.5"
        />
        <line
          fill="none"
          style={{ strokeWidth: 0.5 }}
          stroke="#000000"
          x1="0.5"
          y1="15.5"
          x2="23.5"
          y2="15.5"
        />
        <line
          fill="none"
          style={{ strokeWidth: 0.5 }}
          stroke="#000000"
          x1="0.5"
          y1="11.5"
          x2="23.5"
          y2="11.5"
        />
        <circle
          fill="none"
          style={{ strokeWidth: 0.5 }}
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="7.6418"
          cy="3.5643"
          r="0.8322"
        />
        <circle
          fill="none"
          style={{ strokeWidth: 0.5 }}
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="16.3583"
          cy="3.5643"
          r="0.8322"
        />
      </g>
      <rect x="0" y="0" fill="none" width="24" height="24" />
    </svg>
  ),

  arrowBackLeft: (
    <svg width={24} height={24} viewBox="0 0 24 24">
      <g transform="rotate(0, 12, 12)">
        <path fill="white" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
      </g>
    </svg>
  ),

  backCircle: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <circle
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="11.9898"
          cy="12.0017"
          r="11.3071"
        />
        <polyline
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points={`\
  11.0474,16.7465 6.3026,12.0017 11.0474,7.2569   `}
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="17.7845"
          y1="12.0017"
          x2="6.3026"
          y2="12.0017"
        />
      </g>
      <rect x="-0.0086" y="-0.0147" fill="none" width="24" height="24" />
    </svg>
  ),

  backCircleWhite: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <circle
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="11.9898"
          cy="12.0017"
          r="11.3071"
        />
        <polyline
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points={`\
  11.0474,16.7465 6.3026,12.0017 11.0474,7.2569   `}
        />
        <line
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="17.7845"
          y1="12.0017"
          x2="6.3026"
          y2="12.0017"
        />
      </g>
      <rect x="-0.0086" y="-0.0147" fill="none" width="24" height="24" />
    </svg>
  ),

  nextCircle: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <circle
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="11.996"
          cy="12.0017"
          r="11.3071"
        />
        <polyline
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points={`\
  12.9384,7.2569 17.6833,12.0017 12.9384,16.7466  `}
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="6.2013"
          y1="12.0017"
          x2="17.6833"
          y2="12.0017"
        />
      </g>
      <rect x="-0.0086" y="-0.0147" fill="none" width="24" height="24" />
    </svg>
  ),

  nextCircleWhite: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <circle
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="11.996"
          cy="12.0017"
          r="11.3071"
        />
        <polyline
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points={`\
  12.9384,7.2569 17.6833,12.0017 12.9384,16.7466  `}
        />
        <line
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="6.2013"
          y1="12.0017"
          x2="17.6833"
          y2="12.0017"
        />
      </g>
      <rect x="-0.0086" y="-0.0147" fill="none" width="24" height="24" />
    </svg>
  ),

  privacyOn: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <ellipse
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="12.0458"
          cy="12.0092"
          rx="4.4059"
          ry="4.5409"
        />
        <ellipse
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="12.0458"
          cy="12.0094"
          rx="1.812"
          ry="1.8675"
        />
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M23.1063,12.0096 \
  c-2.2226-4.4918-6.3423-7.5107-11.0604-7.5107c-4.7184,0-8.8379,3.0189-11.0605,7.5107c2.2226,4.4917,6.3421,7.5107,11.0605,7.5107 \
  C16.764,19.5203,20.8836,16.5014,23.1063,12.0096z`}
        />
      </g>
      <rect x="0" y="0" fill="none" width="24" height="24" />
    </svg>
  ),

  privacyOff: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <line
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="0.884"
          y1="23.1223"
          x2="23.2432"
          y2="0.7631"
        />
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M8.0824,13.5617 \
  c-1.4277-3.5064,2.0766-7.0347,5.6004-5.6004`}
        />
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M16.3461,5.2979 \
  C10.5215,2.9892,3.9474,5.6364,0.7315,11.9427c1.0061,1.973,2.3926,3.6584,4.0428,4.9272`}
        />
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M16.0449,10.3235 \
  c1.4244,3.4998-2.0708,7.0372-5.6003,5.6003`}
        />
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M7.781,18.5875 \
  c5.8245,2.3087,12.3988-0.3385,15.6147-6.6448c-1.0061-1.973-2.3927-3.6584-4.0429-4.9272`}
        />
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M13.9536,12.4148 \
  c-0.1741,0.6978-0.7199,1.2437-1.4179,1.4179`}
        />
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M10.4446,15.9238 \
  c3.5272,1.4359,7.0262-2.0968,5.6003-5.6003`}
        />
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M11.5919,10.0522 \
  c-0.6984,0.174-1.2448,0.7203-1.4188,1.4188`}
        />
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M12.5358,13.8327 \
  c0.6979-0.1741,1.2437-0.72,1.4179-1.4179`}
        />
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),

  attachment: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M5.5317,23.0146c-1.3716,0-2.6602-0.5439-3.6284-1.5322c-1.9937-2.0332-1.9937-5.3418-0.0005-7.375L12.3174,3.48 \
  c0.1943-0.1953,0.5107-0.2007,0.707-0.0068c0.1973,0.1934,0.2012,0.5098,0.0078,0.707L2.6167,14.8066 \
  c-1.6147,1.6484-1.6147,4.3291,0.0005,5.9766c0.7788,0.7939,1.814,1.2314,2.9141,1.2314c1.1006,0,2.1348-0.4375,2.9136-1.2314 \
  L21.7217,7.2344c1.1641-1.187,1.1641-3.1187,0-4.3062c-1.1191-1.1431-3.0713-1.144-4.1924,0L6.9102,13.7627 \
  c-0.7124,0.7285-0.7124,1.9121,0,2.6396c0.3423,0.3486,0.7959,0.541,1.2778,0.541h0.0005c0.4819,0,0.936-0.1924,1.2783-0.541 \
  l7.7568-7.916c0.1943-0.1953,0.5107-0.2007,0.707-0.0068c0.1973,0.1934,0.2012,0.5098,0.0078,0.707l-7.7578,7.915 \
  c-0.5317,0.543-1.2393,0.8418-1.9922,0.8418c-0.0005,0-0.0005,0-0.0005,0c-0.7534,0-1.4604-0.2988-1.9922-0.8418 \
  c-1.0903-1.1123-1.0903-2.9238,0-4.0381L16.8145,2.228c0.75-0.7651,1.748-1.1865,2.8105-1.187c1.0625,0,2.0605,0.4214,2.8115,1.187 \
  c1.542,1.5737,1.541,4.1333,0,5.7065L9.1587,21.4824C8.1909,22.4707,6.9028,23.0146,5.5317,23.0146z`}
        />
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),

  smsOn: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M12.4688,24.0068H3.5322c-1.396,0-2.5317-1.1357-2.5317-2.5312V2.5029c0-1.3955,1.1357-2.5312,2.5317-2.5312h8.9365 \
  C13.8643-0.0283,15,1.1074,15,2.5029c0,0.2764-0.2236,0.5-0.5,0.5s-0.5-0.2236-0.5-0.5c0-0.8442-0.6865-1.5312-1.5312-1.5312 \
  H3.5322c-0.8447,0-1.5317,0.687-1.5317,1.5312v18.9727c0,0.8447,0.687,1.5312,1.5317,1.5312h8.9365 \
  c0.8447,0,1.5312-0.6865,1.5312-1.5312v-5.999c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5v5.999 \
  C15,22.8711,13.8643,24.0068,12.4688,24.0068z`}
        />
        <path
          d={`M8.0005,22.3809c-0.7461,0-1.3535-0.6074-1.3535-1.3535s0.6074-1.3525,1.3535-1.3525s1.353,0.6064,1.353,1.3525 \
  S8.7466,22.3809,8.0005,22.3809z M8.0005,20.6748c-0.1948,0-0.3535,0.1582-0.3535,0.3525c0,0.1953,0.1587,0.3535,0.3535,0.3535 \
  s0.353-0.1582,0.353-0.3535C8.3535,20.833,8.1953,20.6748,8.0005,20.6748z`}
        />
        <path
          d={`M14.5088,18.998H1.5093c-0.2764,0-0.5-0.2236-0.5-0.5v-15c0-0.2764,0.2236-0.5,0.5-0.5h9.1523c0.2764,0,0.5,0.2236,0.5,0.5 \
  s-0.2236,0.5-0.5,0.5H2.0093v14h12.4995c0.2764,0,0.5,0.2236,0.5,0.5S14.7852,18.998,14.5088,18.998z`}
        />
        <path
          d={`M12.5049,17.5908c-0.0732,0-0.1465-0.0156-0.2158-0.0488c-0.1738-0.083-0.2842-0.2588-0.2842-0.4512v-3.4746 \
  c-1.981-0.6553-3.9761-2.9028-3.9761-5.7065c0-3.2598,2.4692-5.9116,5.5044-5.9116h4.9834c2.9902,0,5.4229,2.6914,5.4229,6 \
  s-2.4326,6-5.4229,6H17.124l-4.3047,3.4814C12.7285,17.5527,12.6172,17.5908,12.5049,17.5908z M13.5332,2.998 \
  c-2.4414,0-4.5044,2.249-4.5044,4.9116c0,2.4937,1.8608,4.4536,3.5854,4.8384c0.2285,0.0518,0.3906,0.2539,0.3906,0.4883v2.8066 \
  l3.6279-2.9336c0.0889-0.0723,0.2002-0.1113,0.3145-0.1113h1.5693c2.3975,0,4.4229-2.2896,4.4229-5s-2.0254-5-4.4229-5H13.5332z`}
        />
        <path
          d={`M12.1104,10.0288c-0.3813,0-0.8638-0.1807-1.2002-0.4497c-0.2158-0.1724-0.251-0.4873-0.0786-0.7026 \
  c0.1729-0.2148,0.4883-0.251,0.7026-0.0786c0.1704,0.1362,0.4404,0.231,0.5762,0.231c0.168,0,0.2695-0.0845,0.2822-0.1216l0,0 \
  c-0.0166,0-0.1104-0.0723-0.4121-0.1533c-0.3218-0.0928-1.1538-0.3325-1.1538-1.1118c0-0.6226,0.5757-1.1289,1.2837-1.1289 \
  c0.4463,0,0.8535,0.1973,1.0879,0.5273c0.1602,0.2251,0.1074,0.5376-0.1172,0.6973c-0.2246,0.1592-0.5371,0.1069-0.6973-0.1172 \
  c-0.0371-0.0518-0.1377-0.1074-0.2734-0.1074c-0.1738,0-0.2764,0.0913-0.2832,0.1255c0.002-0.0151,0.0898,0.0562,0.4219,0.1519 \
  c0.7568,0.2031,1.1455,0.5771,1.1455,1.1094C13.3945,9.5225,12.8184,10.0288,12.1104,10.0288z`}
        />
        <path
          d={`M20.4658,10.0288c-0.3809,0-0.8633-0.1807-1.2002-0.4497c-0.2158-0.1724-0.25-0.4873-0.0781-0.7026 \
  c0.1729-0.2153,0.4863-0.25,0.7031-0.0786c0.1699,0.1362,0.4395,0.231,0.5752,0.231c0.1709,0,0.2695-0.084,0.2832-0.1216 \
  c-0.001,0-0.001,0-0.001,0c-0.0166,0-0.1104-0.0723-0.4121-0.1533c-0.3213-0.0928-1.1533-0.332-1.1533-1.1118 \
  c0-0.6226,0.5752-1.1289,1.2832-1.1289c0.4463,0,0.8535,0.1973,1.0879,0.5273c0.1602,0.2251,0.1074,0.5376-0.1172,0.6973 \
  c-0.2236,0.1592-0.5361,0.1069-0.6973-0.1172c-0.0371-0.0518-0.1377-0.1074-0.2734-0.1074c-0.1768,0-0.2764,0.0908-0.2832,0.1255 \
  c0.0225-0.0215,0.0996,0.0586,0.4219,0.1519C21.3613,7.9937,21.75,8.3677,21.75,8.8999 \
  C21.75,9.5225,21.1738,10.0288,20.4658,10.0288z`}
        />
        <path
          d={`M14.3408,10.0288c-0.2764,0-0.5-0.2236-0.5-0.5V7.0151c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5v2.5137 \
  C14.8408,9.8052,14.6172,10.0288,14.3408,10.0288z`}
        />
        <path
          d={`M16.293,10.0288c-0.2764,0-0.5-0.2236-0.5-0.5V8.0132c0.001-0.1011-0.0283-0.3159-0.1299-0.4185 \
  c-0.0332-0.0342-0.0957-0.0796-0.251-0.0796c-0.4541,0-0.5615,0.4688-0.5781,0.5625c-0.0488,0.27-0.3008,0.4551-0.5762,0.4072 \
  c-0.2705-0.0454-0.4541-0.2979-0.4111-0.5684c0.0771-0.4849,0.5029-1.4014,1.5654-1.4014c0.4951,0,0.8018,0.2104,0.9727,0.3867 \
  c0.4199,0.4351,0.4102,1.0591,0.4082,1.1289v1.498C16.793,9.8052,16.5693,10.0288,16.293,10.0288z`}
        />
        <path
          d={`M18.2461,10.0288c-0.2764,0-0.5-0.2236-0.5-0.5V8.0132c0.001-0.1006-0.0293-0.3159-0.1299-0.4189 \
  c-0.0342-0.0337-0.0967-0.0791-0.251-0.0791c-0.4844,0-0.5752,0.5356-0.5781,0.5581c-0.0439,0.2729-0.2988,0.457-0.5732,0.415 \
  c-0.2725-0.0435-0.458-0.2998-0.415-0.5723c0.0781-0.4849,0.5049-1.4009,1.5664-1.4009c0.4941,0,0.8008,0.21,0.9717,0.3862 \
  c0.4199,0.4351,0.4111,1.0591,0.4092,1.1289v1.4985C18.7461,9.8052,18.5225,10.0288,18.2461,10.0288z`}
        />
      </g>
      <rect y="-0.002" fill="none" width="24" height="24" />
    </svg>
  ),

  smsOff: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M11.478,24.0068H2.542c-1.396,0-2.5317-1.1357-2.5317-2.5312V2.5029c0-1.3955,1.1357-2.5312,2.5317-2.5312h8.936 \
  c1.396,0,2.5317,1.1357,2.5317,2.5312v18.9727C14.0098,22.8711,12.874,24.0068,11.478,24.0068z M2.542,0.9717 \
  c-0.8447,0-1.5317,0.687-1.5317,1.5312v18.9727c0,0.8447,0.687,1.5312,1.5317,1.5312h8.936c0.8442,0,1.5317-0.6865,1.5317-1.5312 \
  V2.5029c0-0.8442-0.6875-1.5312-1.5317-1.5312H2.542z`}
        />
        <path
          d={`M7.0098,22.3809c-0.7461,0-1.353-0.6074-1.353-1.3535s0.6069-1.3525,1.353-1.3525s1.3535,0.6064,1.3535,1.3525 \
  S7.7559,22.3809,7.0098,22.3809z M7.0098,20.6748c-0.1948,0-0.353,0.1582-0.353,0.3525c0,0.1953,0.1582,0.3535,0.353,0.3535 \
  s0.3535-0.1582,0.3535-0.3535C7.3633,20.833,7.2046,20.6748,7.0098,20.6748z`}
        />
        <path
          d={`M13.5186,18.998h-13c-0.2764,0-0.5-0.2236-0.5-0.5v-15c0-0.2764,0.2236-0.5,0.5-0.5h13c0.2764,0,0.5,0.2236,0.5,0.5v15 \
  C14.0186,18.7744,13.7949,18.998,13.5186,18.998z M1.0186,17.998h12v-14h-12V17.998z`}
        />
        <g transform="scale(1.5) translate(-6.8, -7)">
          <path
            d={`M14.5205,17.7998c-0.1279,0-0.2559-0.0488-0.3535-0.1465l-5.9131-5.9131c-0.1953-0.1953-0.1953-0.5117,0-0.707 \
  s0.5117-0.1953,0.707,0l5.9131,5.9131c0.1953,0.1953,0.1953,0.5117,0,0.707C14.7764,17.751,14.6484,17.7998,14.5205,17.7998z`}
          />
          <path
            d={`M8.6074,17.7998c-0.1279,0-0.2559-0.0488-0.3535-0.1465c-0.1953-0.1953-0.1953-0.5117,0-0.707l5.9131-5.9131 \
  c0.1953-0.1953,0.5117-0.1953,0.707,0s0.1953,0.5117,0,0.707l-5.9131,5.9131C8.8633,17.751,8.7354,17.7998,8.6074,17.7998z`}
          />
        </g>
      </g>
      <rect y="-0.002" fill="none" width="24" height="24" />
    </svg>
  ),

  caretDown: (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24">
      <path fill="#90A4AE" d="M7 10l5 5 5-5z" />
    </svg>
  ),

  graph: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="#FFFFFF"
          d={`M5.7363,24.0049H1.1484c-0.6646,0-1.2056-0.5273-1.2056-1.1748v-3.6045c0-0.6611,0.5522-1.2197,1.2056-1.2197h4.5879 \
  c0.6538,0,1.2065,0.5586,1.2065,1.2197v3.6045C6.9429,23.4775,6.4019,24.0049,5.7363,24.0049z M1.1484,19.0059 \
  c-0.1055,0-0.2056,0.1064-0.2056,0.2197v3.6045c0,0.1133,0.106,0.1748,0.2056,0.1748h4.5879c0.1016,0,0.2065-0.0654,0.2065-0.1748 \
  v-3.6045c0-0.1113-0.1025-0.2197-0.2065-0.2197H1.1484z`}
        />
        <path
          fill="#FFFFFF"
          d={`M13.7373,24.0049H9.1494c-0.6646,0-1.2056-0.5273-1.2056-1.1748v-9.6045c0-0.6621,0.5522-1.2207,1.2056-1.2207h4.5879 \
  c0.6543,0,1.207,0.5586,1.207,1.2207v9.6045C14.9443,23.4775,14.4033,24.0049,13.7373,24.0049z M9.1494,13.0049 \
  c-0.1055,0-0.2056,0.1074-0.2056,0.2207v9.6045c0,0.1133,0.106,0.1748,0.2056,0.1748h4.5879c0.1016,0,0.207-0.0654,0.207-0.1748 \
  v-9.6045c0-0.1113-0.1025-0.2207-0.207-0.2207H9.1494z`}
        />
        <path
          fill="#FFFFFF"
          d={`M21.7383,24.0049h-4.5879c-0.665,0-1.2061-0.5273-1.2061-1.1748V3.2241c0-0.6611,0.5527-1.2197,1.2061-1.2197h4.5879 \
  c0.6533,0,1.2061,0.5586,1.2061,1.2197v19.606C22.9443,23.4775,22.4033,24.0049,21.7383,24.0049z M17.1504,3.0044 \
  c-0.1055,0-0.2061,0.1069-0.2061,0.2197v19.606c0,0.1133,0.1064,0.1748,0.2061,0.1748h4.5879c0.1016,0,0.2061-0.0654,0.2061-0.1748 \
  V3.2241c0-0.1108-0.1025-0.2197-0.2061-0.2197H17.1504z`}
        />
        <path
          fill="#FFFFFF"
          d={`M1.4434,12.9736c-0.1279,0-0.2559-0.0488-0.3535-0.1465c-0.1953-0.1953-0.1953-0.5117,0-0.707l8.9614-8.9609 \
  c0.1953-0.1953,0.5117-0.1953,0.707,0s0.1953,0.5117,0,0.707l-8.9614,8.9609C1.6992,12.9248,1.5713,12.9736,1.4434,12.9736z`}
        />
        <path
          fill="#FFFFFF"
          d={`M10.4863,8.5c-0.2764,0-0.5-0.2236-0.5-0.5V4h-4c-0.2764,0-0.5-0.2236-0.5-0.5S5.71,3,5.9863,3h4.5 \
  c0.2764,0,0.5,0.2236,0.5,0.5V8C10.9863,8.2764,10.7627,8.5,10.4863,8.5z`}
        />
      </g>
    </svg>
  ),

  graph2: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g stroke="#FFFFFF">
        <path
          d={`M2.0132,13.0762c-0.8965,0-1.6255-0.7285-1.6255-1.625s0.729-1.6255,1.6255-1.6255c0.896,0,1.625,0.729,1.625,1.6255 \
  S2.9092,13.0762,2.0132,13.0762z M2.0132,10.8257c-0.3447,0-0.6255,0.2808-0.6255,0.6255s0.2808,0.625,0.6255,0.625 \
  s0.625-0.2803,0.625-0.625S2.3579,10.8257,2.0132,10.8257z`}
        />
        <path
          d={`M8.6323,8.8643c-0.8965,0-1.6255-0.729-1.6255-1.6255c0-0.896,0.729-1.625,1.6255-1.625c0.896,0,1.625,0.729,1.625,1.625 \
  C10.2573,8.1353,9.5283,8.8643,8.6323,8.8643z M8.6323,6.6138c-0.3447,0-0.6255,0.2803-0.6255,0.625s0.2808,0.6255,0.6255,0.6255 \
  s0.625-0.2808,0.625-0.6255S8.9771,6.6138,8.6323,6.6138z`}
        />
        <path
          d={`M15.251,19.0938c-0.8965,0-1.625-0.7285-1.625-1.625s0.7285-1.625,1.625-1.625s1.626,0.7285,1.626,1.625 \
  S16.1475,19.0938,15.251,19.0938z M15.251,16.8438c-0.3447,0-0.625,0.2803-0.625,0.625s0.2803,0.625,0.625,0.625 \
  s0.626-0.2803,0.626-0.625S15.5957,16.8438,15.251,16.8438z`}
        />
        <path
          d={`M21.8701,11.873c-0.8965,0-1.625-0.729-1.625-1.6255c0-0.896,0.7285-1.625,1.625-1.625s1.626,0.729,1.626,1.625 \
  C23.4961,11.144,22.7666,11.873,21.8701,11.873z M21.8701,9.6226c-0.3447,0-0.625,0.2803-0.625,0.625s0.2803,0.6255,0.625,0.6255 \
  s0.626-0.2808,0.626-0.6255S22.2148,9.6226,21.8701,9.6226z`}
        />
        <path
          d={`M2.9609,11.3481c-0.166,0-0.3281-0.0825-0.4233-0.2329c-0.1475-0.2334-0.0776-0.5425,0.1558-0.6899l4.7334-2.9897 \
  c0.2354-0.1465,0.5425-0.0767,0.6899,0.1558c0.1475,0.2334,0.0776,0.5425-0.1558,0.6899L3.2275,11.271 \
  C3.1445,11.3232,3.0522,11.3481,2.9609,11.3481z`}
        />
        <path
          d={`M14.6406,17.0254c-0.1631,0-0.3242-0.0801-0.4199-0.2285L8.8228,8.4536C8.6729,8.2217,8.7393,7.9121,8.9712,7.7622 \
  c0.2319-0.1504,0.5415-0.084,0.6914,0.1484l5.3979,8.3433c0.1494,0.2314,0.084,0.541-0.1484,0.6914 \
  C14.8281,16.999,14.7344,17.0254,14.6406,17.0254z`}
        />
        <path
          d={`M16.0098,17.1416c-0.1211,0-0.2422-0.043-0.3379-0.1318c-0.2031-0.1865-0.2178-0.502-0.0303-0.7061l5.085-5.5479 \
  c0.1875-0.2041,0.5049-0.2163,0.7061-0.0308c0.2031,0.1865,0.2178,0.5029,0.0303,0.7065l-5.085,5.5479 \
  C16.2793,17.0869,16.1445,17.1416,16.0098,17.1416z`}
        />
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),

  highlight: (
    <svg version="1.1" x={0} y={0} width={24} height={24} viewBox="0 0 24 24">
      <g transform="matrix(0.74592752,0.66602713,-0.66602713,0.74592752,12.919821,-6.6369424)">
        <path
          d="M 15.1151,17.5029 14.4515,1.6487 c 0,-0.6603 -0.3598,-1.1459 -0.8037,-1.1459 l -3.1754,0 c -0.4439,0 -0.8037,0.4856 -0.8037,1.1459 l -0.6634,15.8542 6.1098,0 z"
          fill="#FFFFFF"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m 14.8867,17.5148 c 0,0 -2.171,1.7457 -2.2169,4.0846 l -1.2193,0 C 11.4046,19.2605 9.2336,17.5148 9.2336,17.5148"
          fill="#FFFFFF"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polygon
          points="12.6705,22.9375 12.6699,21.5994 11.4505,21.5994 11.3836,23.2904 "
          fill="#FFFFFF"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <rect
        fill="none"
        fillRule="evenodd"
        stroke="#FFFFFF"
        strokeWidth={1}
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeOpacity={1}
        width={22}
        height={4}
        x={0}
        y={19}
        ry={1.5}
      />
    </svg>
  ),

  camera: (
    <svg version="1.1" x={0} y={0} width={24} height={24} viewBox="0 0 24 24">
      <circle
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        cx="15.5286"
        cy="19.0043"
        r="2.5282"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d={`M16.7835,12.536 \
  c1.2141,0,1.6475,0.6556,1.7355,1.9442h3.5887c1.0648,0,1.35,1.1086,1.3857,1.6078l0.0114,5.8953 \
  c0,1.0575-0.9022,1.4473-1.3927,1.4955l0.0076,0.0214H9.8963c-0.4775,0-0.8252-0.1672-1.0858-0.4587 \
  c-0.3621-0.4034-0.3186-0.9458-0.3186-1.0732V16.088c0-1.2073,0.9125-1.5846,1.4508-1.6081h2.5963 \
  c0.088-1.2886,0.5214-1.9442,1.7355-1.9442L16.7835,12.536z`}
      />
      <line
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        x1="20.4527"
        y1="17.47"
        x2="20.4527"
        y2="17.47"
      />
    </svg>
  ),

  cameraUpload: (
    <svg version="1.1" x={0} y={0} width={64} height={64} viewBox="0 0 24 24">
      <line
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        x1="11.4863"
        y1="1.595"
        x2="11.4863"
        y2="12.4519"
      />
      <polyline
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points={`\
  7.9577,5.1318 11.4945,1.595 15.0314,5.1318 	`}
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d={`M11.4945,20.4698 \
  c-1.6483,0-2.9889-1.3406-2.9889-2.9884c0-1.6483,1.3406-2.9889,2.9889-2.9889c1.6478,0,2.9886,1.3406,2.9886,2.9889 \
  C14.4831,19.1292,13.1423,20.4698,11.4945,20.4698z`}
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d={`M13.4581,10.5963 \
  c0.6969,0.2293,0.9805,0.8261,1.0521,1.8886h4.4939c1.1495,0,1.4761,0.892,1.5146,1.438v7.1501 \
  c0,1.3499-1.5303,1.4037-1.5303,1.4037L6.0117,22.5001c-0.5155,0-0.8909-0.1828-1.1722-0.5017 \
  c-0.3909-0.4412-0.3439-1.0345-0.3439-1.1738v-6.4318c0-1.3205,0.9851-1.8825,1.5663-1.9083h2.4415 \
  c0.0737-1.0935,0.268-1.6937,0.9636-1.9077`}
      />
      <line
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        x1="17.4571"
        y1="15.4698"
        x2="17.4571"
        y2="15.4698"
      />
    </svg>
  ),

  exitCircle: (
    <svg
      className="white"
      x={0}
      y={0}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="16.6292"
          y1="7.3818"
          x2="7.3878"
          y2="16.6232"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="7.3878"
          y1="7.3818"
          x2="16.6292"
          y2="16.6232"
        />
        <circle
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="12.0067"
          cy="12.0025"
          r="11.3822"
        />
      </g>
      <rect x="0" y="0.001" fill="none" width={24} height={24} />
    </svg>
  ),

  hamburgerMenu: (
    <svg
      className="white"
      x={0}
      y={0}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="22.4752"
          y1="5.4967"
          x2="1.5181"
          y2="5.4967"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="22.4752"
          y1="12.4983"
          x2="1.5181"
          y2="12.4983"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="22.4752"
          y1="19.4999"
          x2="1.5181"
          y2="19.4999"
        />
      </g>
      <rect fill="none" width={24} height={24} />
    </svg>
  ),

  heart: (
    <svg className="white" x={0} y={0} width={24} height={24} viewBox="0 0 24 24">
      <g>
        <polyline
          fill="none"
          stroke="white"
          strokeWidth={1}
          points="1.0142,13.5346 8.1336,13.5346 9.8223,7.1366 12.3022,17.7985 13.7841,10.5457 15.112,13.5346 23.0142,13.5346  "
        />
        <path
          fill="none"
          stroke="white"
          strokeWidth={1.1}
          d={`M2.2601,11.5894 \
  c-0.9151-1.0928-1.4193-2.4801-1.4193-3.906c0-3.3559,2.733-6.088,6.0902-6.088c2.0242,0,3.9201,0.9875,5.0831,2.5156h-0.0017 \
  c1.163-1.5281,3.0589-2.5156,5.0831-2.5156c3.3572,0,6.0902,2.732,6.0902,6.088c0,1.426-0.5042,2.8132-1.4193,3.906`}
        />
        <path
          fill="none"
          stroke="white"
          strokeWidth={1.2}
          d={`M5.6551,15.5901 \
  l5.4794,6.4776c0.401,0.4735,1.1269,0.4745,1.5306,0.0099l5.6298-6.4875`}
        />
      </g>
    </svg>
  ),

  homeIcon: (
    <svg
      className="white-alt"
      x={0}
      y={0}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M20.7383,23.9736h-6.127c-0.2764,0-0.5-0.2236-0.5-0.5v-8.2607H9.9414v8.2607c0,0.2764-0.2236,0.5-0.5,0.5h-6.127 \
  c-0.7056,0-1.2798-0.582-1.2798-1.2979v-9.4697c-0.1621,0.0322-0.3384,0.0557-0.5146,0.0557c-0.5527,0-0.8589-0.2295-1.0186-0.4229 \
  c-0.6167-0.7451-0.5254-1.8647,0.2041-2.4956L10.877,1.5327c0.603-0.5215,1.5439-0.5503,2.1768-0.0732 \
  c0.0459,0.019,0.0879,0.0435,0.1221,0.0732l10.1709,8.8105c0.7295,0.6309,0.8213,1.7505,0.2041,2.4956 \
  c-0.1592,0.1934-0.4658,0.4229-1.0176,0.4229c-0.1768,0-0.3525-0.0234-0.5146-0.0557v9.4697 \
  C22.0186,23.3916,21.4443,23.9736,20.7383,23.9736z M15.1113,22.9736h5.627c0.1543,0,0.2803-0.1338,0.2803-0.2979V12.5293 \
  c0-0.1689,0.085-0.3252,0.2266-0.418c0.1387-0.0918,0.3184-0.1094,0.4736-0.04c0.1221,0.0527,0.5059,0.1904,0.8145,0.1904 \
  c0.1221,0,0.2168-0.0225,0.248-0.0596c0.2725-0.3301,0.2324-0.8247-0.0889-1.1025L12.5996,2.3564 \
  c-0.041-0.0181-0.0781-0.0405-0.1094-0.0674c-0.2695-0.2334-0.6904-0.2334-0.959,0L1.3599,11.0991 \
  c-0.3213,0.2783-0.3608,0.7729-0.0879,1.103c0.0308,0.0371,0.1255,0.0596,0.248,0.0596c0.311,0,0.7012-0.1406,0.8135-0.1904 \
  c0.1548-0.0674,0.3335-0.0518,0.4746,0.0391c0.1411,0.0928,0.2266,0.25,0.2266,0.4189v10.1465 \
  c0,0.1641,0.1255,0.2979,0.2798,0.2979h5.627v-8.2607c0-0.2764,0.2236-0.5,0.5-0.5h5.1699c0.2764,0,0.5,0.2236,0.5,0.5V22.9736z`}
        />
      </g>
      <rect fill="none" width={24} height={24} />
    </svg>
  ),

  contactsIcon: (
    <svg
      className="white"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M15.4971,23.8213c-0.2764,0-0.5-0.2236-0.5-0.5v-1c0-0.0752-0.04-0.1426-0.1006-0.166 \
  c-2.7471-1.0947-4.7642-2.6035-5.1392-3.8438c-0.0142-0.0469-0.0215-0.0957-0.0215-0.1445v-0.9482 \
  c0-0.1279,0.0488-0.251,0.1372-0.3438c0.5586-0.5898,0.9917-1.4102,1.252-2.3711c0.0298-0.1104,0.0967-0.207,0.189-0.2744 \
  c0.2202-0.1592,0.3696-0.4141,0.4092-0.6973c0.0405-0.293-0.0381-0.583-0.2217-0.8164c-0.0693-0.0889-0.1069-0.1973-0.1069-0.3096 \
  v-2.1235c0-2.1182-1.1401-3.1924-3.3887-3.1924c-2.186,0-3.3896,1.1338-3.3896,3.1924v2.1245c0,0.1123-0.0376,0.2217-0.1074,0.3096 \
  c-0.1826,0.2324-0.2612,0.5205-0.2207,0.8135c0.0396,0.2842,0.1885,0.5391,0.4087,0.6992c0.0928,0.0664,0.1592,0.1631,0.189,0.2734 \
  c0.2603,0.9619,0.6934,1.7822,1.2524,2.3721c0.0879,0.0928,0.1372,0.2158,0.1372,0.3438v0.9482 \
  c0,0.0488-0.0073,0.0977-0.0215,0.1445c-0.3735,1.2383-2.3911,2.7471-5.1396,3.8438c-0.0591,0.0234-0.1001,0.0908-0.1001,0.166v1 \
  c0,0.2764-0.2236,0.5-0.5,0.5s-0.5-0.2236-0.5-0.5v-1c0-0.4873,0.2861-0.917,0.7285-1.0947 \
  c2.8994-1.1562,4.2759-2.4844,4.5327-3.1426v-0.6719c-0.5752-0.6582-1.0244-1.5117-1.3101-2.4893 \
  c-0.3599-0.3184-0.6001-0.7656-0.668-1.2559c-0.0693-0.5029,0.0435-1.001,0.3188-1.4209v-1.9634 \
  c0-2.625,1.6411-4.1924,4.3896-4.1924c2.7891,0,4.3887,1.5278,4.3887,4.1924v1.9634c0.2764,0.4209,0.3896,0.9199,0.3193,1.4238 \
  c-0.0684,0.4893-0.3086,0.9365-0.668,1.2539c-0.2861,0.9766-0.7354,1.8301-1.3101,2.4883v0.6719 \
  c0.2578,0.6592,1.6343,1.9883,4.5308,3.1416c0.4443,0.1768,0.7305,0.6074,0.7305,1.0957v1 \
  C15.9971,23.5977,15.7734,23.8213,15.4971,23.8213z`}
        />
        <path
          d={`M15.4971,14.3604c-0.0713,0-0.1436-0.0156-0.2109-0.0469c-0.1758-0.082-0.2891-0.2588-0.2891-0.4531v-2.8657h-0.7002 \
  c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5h1.2002c0.2764,0,0.5,0.2236,0.5,0.5v2.2896l3.416-2.8833 \
  c0.0654-0.0547,0.1436-0.0923,0.2275-0.1084c1.8984-0.3682,3.2773-2.1846,3.2773-4.3184c0-2.4185-1.7803-4.3862-3.9688-4.3862 \
  h-4.5225c-1.918,0-3.5596,1.5103-3.9048,3.5913c-0.0454,0.2725-0.3052,0.458-0.5747,0.4116 \
  c-0.2725-0.0449-0.457-0.3022-0.4116-0.5747c0.4253-2.5659,2.4819-4.4282,4.8911-4.4282h4.5225 \
  c2.7402,0,4.9688,2.416,4.9688,5.3862c0,2.5635-1.6562,4.7583-3.957,5.2725l-4.1416,3.4956 \
  C15.7275,14.3203,15.6133,14.3604,15.4971,14.3604z`}
        />
        <path
          d={`M19.3896,5h-5.8164c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5h5.8164c0.2764,0,0.5,0.2236,0.5,0.5 \
  S19.666,5,19.3896,5z`}
        />
        <path
          d={`M16.4814,7h-2.9082c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5h2.9082c0.2764,0,0.5,0.2236,0.5,0.5 \
  S16.7578,7,16.4814,7z`}
        />
      </g>
      <rect fill="none" width="24" height="24" />
    </svg>
  ),

  diaryIcon: (
    <svg
      className="white-alt"
      x={0}
      y={0}
      viewBox="0 0 24 24"
      width={24}
      height={24}
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M21.1211,24H2.8789C1.2915,24,0,22.709,0,21.1211V2.8784C0,1.291,1.2915,0,2.8789,0h18.2422C22.709,0,24,1.291,24,2.8784 \
  v18.2427C24,22.709,22.709,24,21.1211,24z M2.8789,1C1.8428,1,1,1.8428,1,2.8784v18.2427C1,22.1572,1.8428,23,2.8789,23h18.2422 \
  C22.1572,23,23,22.1572,23,21.1211V2.8784C23,1.8428,22.1572,1,21.1211,1H2.8789z`}
        />
        <path d="M23.5,7h-23C0.2236,7,0,6.7764,0,6.5S0.2236,6,0.5,6h23C23.7764,6,24,6.2236,24,6.5S23.7764,7,23.5,7z" />
        <path
          d={`M7.5098,4.0898c-0.1401,0-0.27-0.0601-0.3599-0.1499C7.0601,3.8496,7.0098,3.7197,7.0098,3.5898S7.0601,3.3296,7.1499,3.23 \
  c0.1797-0.1802,0.52-0.1899,0.71,0c0.0898,0.0996,0.1499,0.23,0.1499,0.3599S7.9497,3.8496,7.8599,3.9399 \
  C7.7598,4.04,7.6396,4.0898,7.5098,4.0898z`}
        />
        <path
          d={`M16.5098,4.0898c-0.1396,0-0.2695-0.0601-0.3604-0.1499c-0.0898-0.0903-0.1396-0.2202-0.1396-0.3501 \
  s0.0498-0.2603,0.1396-0.3599c0.1904-0.1802,0.5205-0.1802,0.71,0c0.1006,0.0996,0.1504,0.23,0.1504,0.3599 \
  s-0.0498,0.25-0.1504,0.3501C16.7695,4.04,16.6396,4.0898,16.5098,4.0898z`}
        />
        <path
          d={`M16.5078,19.9229c-0.2764,0-0.5-0.2236-0.5-0.5v-8.1973l-1.3955,0.5151c-0.2568,0.0957-0.5469-0.0371-0.6416-0.2959 \
  c-0.0957-0.2593,0.0361-0.5469,0.2959-0.6426l2.0684-0.7637c0.1504-0.0566,0.3242-0.0352,0.459,0.0591 \
  c0.1338,0.0933,0.2139,0.2466,0.2139,0.4102v8.915C17.0078,19.6992,16.7842,19.9229,16.5078,19.9229z`}
        />
        <path
          d={`M9.4531,20.0352c-1.4609,0-2.9717-0.7236-3.5425-1.7783c-0.1318-0.2432-0.0415-0.5469,0.2012-0.6777 \
  c0.2432-0.1309,0.5469-0.042,0.6777,0.2012c0.458,0.8447,2.0293,1.4287,3.2358,1.2031c0.6074-0.1143,1.3594-0.4746,1.4932-1.5439 \
  c0.0781-0.627-0.0459-1.1025-0.3794-1.4521c-0.6704-0.7021-2.0713-0.7529-2.5581-0.7207c-0.208,0.0127-0.3892-0.0889-0.4819-0.2656 \
  c-0.0928-0.1777-0.0713-0.3936,0.0552-0.5479l2.8076-3.4453H6.6704c-0.2764,0-0.5-0.2236-0.5-0.5s0.2236-0.5,0.5-0.5h5.3442 \
  c0.1934,0,0.3691,0.1113,0.4512,0.2856c0.083,0.1743,0.0586,0.3809-0.0635,0.5303l-2.8369,3.481 \
  c0.7261,0.0869,1.667,0.332,2.2969,0.9922c0.5469,0.5732,0.7646,1.335,0.6484,2.2666c-0.1602,1.2822-0.9985,2.1582-2.3003,2.4023 \
  C9.9634,20.0127,9.7085,20.0352,9.4531,20.0352z`}
        />
      </g>
    </svg>
  ),

  financesIcon: (
    <svg
      className="white-alt"
      x={0}
      y={0}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M7.4541,20.5859c-0.1265,0-0.2534-0.0479-0.3506-0.1436l-6.103-6.0059c-0.0952-0.0938-0.1489-0.2207-0.1494-0.3545 \
  c-0.0005-0.1328,0.0522-0.2617,0.1465-0.3555l13.437-13.438c0.1875-0.1875,0.5195-0.1875,0.707,0l7.4053,7.4048 \
  c0.1953,0.1948,0.1953,0.5107,0.001,0.7061l-3.7275,3.75c-0.1943,0.1963-0.5107,0.1963-0.707,0.0029 \
  c-0.1953-0.1948-0.1963-0.5117-0.002-0.7075l3.376-3.397l-6.6992-6.6987L2.061,14.0771l5.7437,5.6523 \
  c0.1968,0.1934,0.1997,0.5107,0.0059,0.707C7.7124,20.5361,7.5835,20.5859,7.4541,20.5859z`}
        />
        <path
          d={`M20.8574,12.9717c-0.1543,0-0.3076-0.0713-0.4053-0.207c-0.1621-0.2236-0.1113-0.5361,0.1123-0.6982l1.623-1.1743 \
  l-1.2393-1.7124c-0.1621-0.2236-0.1113-0.5361,0.1123-0.6982c0.2236-0.1611,0.5361-0.1118,0.6982,0.1123l1.5322,2.1172 \
  c0.0771,0.1074,0.1094,0.2412,0.0889,0.3721c-0.0215,0.1309-0.0938,0.248-0.2012,0.3262l-2.0283,1.4678 \
  C21.0615,12.9404,20.959,12.9717,20.8574,12.9717z`}
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M22.4508,17.7227"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M22.4508,14.8369"
        />
        <path
          d={`M14.9521,20.0645c-3.9746,0-7.998-0.9834-7.998-2.8643c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5 \
  c0,0.7598,2.7261,1.8643,6.998,1.8643c4.2725,0,6.999-1.1045,6.999-1.8643c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5 \
  C22.9512,19.0811,18.9268,20.0645,14.9521,20.0645z`}
        />
        <path
          d={`M14.9521,22.9502c-3.9746,0-7.998-0.9834-7.998-2.8643v-5.9033c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5v5.9033 \
  c0,0.7598,2.7261,1.8643,6.998,1.8643c4.2725,0,6.999-1.1045,6.999-1.8643v-5.9033c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5 \
  v5.9033C22.9512,21.9668,18.9268,22.9502,14.9521,22.9502z`}
        />
        <path
          d={`M14.9521,17.0459c-3.9746,0-7.998-1.0381-7.998-3.0215s4.0234-3.021,7.998-3.021s7.999,1.0376,7.999,3.021 \
  S18.9268,17.0459,14.9521,17.0459z M14.9521,12.0029c-4.272,0-6.998,1.1973-6.998,2.0215s2.7261,2.0215,6.998,2.0215 \
  c4.2725,0,6.999-1.1973,6.999-2.0215S19.2246,12.0029,14.9521,12.0029z`}
        />
      </g>
      <rect x="-0.0137" y="0.0031" fill="none" width="24" height="24" />
      <rect x="-0.0137" fill="none" width="24" height="24" />
    </svg>
  ),

  reportsIcon: (
    <svg
      className="white-alt"
      x={0}
      y={0}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          d={`M21.124,24.0029H2.8545c-1.5801,0-2.8652-1.2852-2.8652-2.8652V2.8682c0-1.5801,1.2852-2.8652,2.8652-2.8652H21.124 \
  c1.5801,0,2.8652,1.2852,2.8652,2.8652v18.2695C23.9893,22.7178,22.7041,24.0029,21.124,24.0029z M2.8545,1.0029 \
  c-1.0283,0-1.8652,0.8369-1.8652,1.8652v18.2695c0,1.0283,0.8369,1.8652,1.8652,1.8652H21.124 \
  c1.0283,0,1.8652-0.8369,1.8652-1.8652V2.8682c0-1.0283-0.8369-1.8652-1.8652-1.8652H2.8545z`}
        />
        <path
          d={`M6.3657,14.5137c-0.9888,0-1.7935-0.8047-1.7935-1.7939c0-0.9888,0.8047-1.793,1.7935-1.793s1.7935,0.8042,1.7935,1.793 \
  C8.1592,13.709,7.3545,14.5137,6.3657,14.5137z M6.3657,11.9268c-0.4375,0-0.7935,0.3555-0.7935,0.793s0.356,0.7939,0.7935,0.7939 \
  s0.7935-0.3564,0.7935-0.7939S6.8032,11.9268,6.3657,11.9268z`}
        />
        <path
          d={`M12.0244,19.2559c-0.9888,0-1.793-0.8047-1.793-1.793c0-0.9893,0.8042-1.7939,1.793-1.7939 \
  c0.9893,0,1.7939,0.8047,1.7939,1.7939C13.8184,18.4512,13.0137,19.2559,12.0244,19.2559z M12.0244,16.6689 \
  c-0.437,0-0.793,0.3564-0.793,0.7939s0.356,0.793,0.793,0.793c0.4375,0,0.7939-0.3555,0.7939-0.793 \
  S12.4619,16.6689,12.0244,16.6689z`}
        />
        <path
          d={`M17.6836,9.7612c-0.9883,0-1.793-0.8042-1.793-1.793s0.8047-1.7935,1.793-1.7935c0.9893,0,1.7939,0.8047,1.7939,1.7935 \
  S18.6729,9.7612,17.6836,9.7612z M17.6836,7.1748c-0.4375,0-0.793,0.356-0.793,0.7935c0,0.437,0.3555,0.793,0.793,0.793 \
  s0.7939-0.356,0.7939-0.793C18.4775,7.5308,18.1211,7.1748,17.6836,7.1748z`}
        />
        <path
          d={`M23.4893,13.3809c-0.1143,0-0.2295-0.0391-0.3232-0.1182l-4.8174-4.0835C18.1377,9.001,18.1123,8.6851,18.29,8.4746 \
  c0.1807-0.21,0.4951-0.2354,0.7051-0.0581l4.8174,4.0825c0.2109,0.1787,0.2363,0.4941,0.0586,0.7051 \
  C23.7715,13.3213,23.6309,13.3809,23.4893,13.3809z`}
        />
        <path
          d={`M12.6855,16.8535c-0.0879,0-0.1758-0.0225-0.2559-0.0703c-0.2373-0.1416-0.3154-0.4482-0.1738-0.6855l4.3379-7.2778 \
  c0.1416-0.2388,0.4502-0.3154,0.6855-0.1738c0.2373,0.1416,0.3154,0.4482,0.1738,0.6855l-4.3379,7.2778 \
  C13.0215,16.7666,12.8555,16.8535,12.6855,16.8535z`}
        />
        <path
          d={`M11.0356,17.1338c-0.1133,0-0.2271-0.0381-0.3208-0.1172l-3.6807-3.084c-0.2114-0.1768-0.2393-0.4922-0.062-0.7041 \
  c0.1782-0.2119,0.4927-0.2402,0.7046-0.0615l3.6807,3.084c0.2114,0.1768,0.2393,0.4922,0.062,0.7041 \
  C11.3203,17.0732,11.1787,17.1338,11.0356,17.1338z`}
        />
        <path
          d={`M0.4897,18.126c-0.1436,0-0.2856-0.0615-0.3843-0.1797c-0.1772-0.2119-0.1484-0.5273,0.0635-0.7041l4.8853-4.0762 \
  c0.2119-0.1768,0.5273-0.1475,0.7041,0.0635c0.1772,0.2119,0.1484,0.5273-0.0635,0.7041l-4.8853,4.0762 \
  C0.7163,18.0879,0.6025,18.126,0.4897,18.126z`}
        />
      </g>
      <rect x="-0.0136" fill="none" width={24} height={24} />
    </svg>
  ),

  prontoIcon: (
    <svg className="white" version="1.1" id="Layer_1" x="0px" y="0px" width={24} height={24}>
      <g transform="translate(0,-1028.3622)">
        <path
          style={{ stroke: '#fff', strokeWidth: 1 }}
          d="m 5.9874366,1052.2415 c -0.087774,-0.032 -0.1414475,-0.074 -0.1958962,-0.1522 -0.040518,-0.059 -0.3167278,-1.2942 -2.5971413,-11.6233 -1.4739906,-6.6764 -2.5518014,-11.5928 -2.5518014,-11.6399 0,-0.2117 0.15860351,-0.3676 0.3733201,-0.3669 0.087098,3e-4 1.5855806,0.4718 11.3117382,3.5592 6.166237,1.9574 11.243914,3.571 11.283728,3.5859 0.09459,0.035 0.18298,0.114 0.220735,0.1971 0.04,0.088 0.03989,0.2449 -2.33e-4,0.3332 -0.02406,0.053 -1.874634,1.7559 -8.760748,8.0615 -4.80164,4.397 -8.7566516,8.0082 -8.7889156,8.025 -0.079655,0.042 -0.2134483,0.051 -0.2947924,0.021 z m 0.2803427,-0.055 c 0.031069,-0.016 3.9831257,-3.625 8.7823487,-8.0197 7.268501,-6.6559 8.730361,-8.0017 8.752803,-8.0577 0.06116,-0.1529 0.01913,-0.3183 -0.10603,-0.4169 -0.08534,-0.068 -22.5568061,-7.1994 -22.6824212,-7.1991 -0.20692907,6e-4 -0.35411127,0.1656 -0.33439837,0.3747 0.0120893,0.1283 5.09574047,23.1275 5.12414967,23.1824 0.079403,0.1535 0.3035918,0.2195 0.4635482,0.1363 z"
        />
      </g>
    </svg>
  ),

  filofax: (
    <svg
      className="white"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="-10px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M18.2761,15.367 \
  c-1.7711-0.6844-3.7373-1.5343-3.9026-2.0639v-0.5556c0.3674-0.3759,0.6572-0.9001,0.8287-1.5138 \
  c0.409-0.2872,0.5165-0.8834,0.1734-1.3053V8.6847c0-1.2839-0.7149-2.1628-2.3494-2.1628c-1.5923,0-2.3503,0.8789-2.3503,2.1628 \
  v1.2441c-0.3418,0.4207-0.2356,1.0168,0.1734,1.3047c0.1715,0.6139,0.4615,1.1381,0.8291,1.514v0.5556 \
  c-0.1648,0.529-2.1314,1.3791-3.9025,2.0639c-0.151,0.0586-0.2509,0.2054-0.2509,0.3696v1.3895 \
  c0,0.2182,0.1745,0.3955,0.3897,0.3955h10.2224c0.2152,0,0.3897-0.1773,0.3897-0.3955v-1.3895 \
  C18.527,15.5725,18.427,15.4252,18.2761,15.367z`}
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M21.5,1.306 \
  c0-0.4463-0.3614-0.808-0.8071-0.808H4.3072C3.8614,0.498,3.5,0.8598,3.5,1.306V22.69c0,0.4463,0.3614,0.808,0.8071,0.808h16.3857 \
  c0.4458,0,0.8071-0.3618,0.8071-0.808V1.306z`}
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="1.4849"
          y1="20.4977"
          x2="4.584"
          y2="20.4977"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="1.4849"
          y1="17.4974"
          x2="4.584"
          y2="17.4974"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="1.4849"
          y1="14.4971"
          x2="4.584"
          y2="14.4971"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="1.4849"
          y1="11.4968"
          x2="4.584"
          y2="11.4968"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="1.4849"
          y1="8.4965"
          x2="4.584"
          y2="8.4965"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="1.4849"
          y1="5.4962"
          x2="4.584"
          y2="5.4962"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="1.4849"
          y1="2.4959"
          x2="4.584"
          y2="2.4959"
        />
      </g>
      <rect x="0" y="-0.622" fill="none" width="24" height="24" />
    </svg>
  ),

  chat: (
    <svg
      className="white"
      x={0}
      y={0}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <g>
        <path
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M6.6143,17.5146 \
  c-2.94-0.6889-5.926-4.1063-5.926-8.491c0-4.5789,3.5251-8.5255,7.629-8.5255h7.5208c4.1039,0,7.431,3.9212,7.431,8.5001 \
  c0,4.5313-3.3271,8.4999-7.431,8.4999h-2.369l-6.8548,5.78V17.5146z`}
        />
        <ellipse
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="6.7843"
          cy="8.9085"
          rx="1.587"
          ry="1.6194"
        />
        <ellipse
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="11.7652"
          cy="8.9085"
          rx="1.587"
          ry="1.6194"
        />
        <ellipse
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          cx="16.746"
          cy="8.9085"
          rx="1.587"
          ry="1.6194"
        />
      </g>
    </svg>
  ),

  edit: (
    <svg x={0} y={0} width={24} height={24} viewBox="0 0 24 24" enableBackground="new 0 0 24 24">
      <g>
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d={`M20.5061,4.8652 \
    c0-1.3062-1.059-2.365-2.3652-2.365H5.8713c-1.3063,0-2.3652,1.0589-2.3652,2.365V21.135c0,1.3062,1.059,2.365,2.3652,2.365 \
    h12.2695c1.3063,0,2.3652-1.0589,2.3652-2.365V4.8652z`}
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="16.4377"
          y1="8.5001"
          x2="7.5109"
          y2="8.5001"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="16.4377"
          y1="12.5001"
          x2="7.5109"
          y2="12.5001"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="16.4377"
          y1="16.5001"
          x2="7.5109"
          y2="16.5001"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="12.0061"
          y1="0.5106"
          x2="12.0061"
          y2="3.503"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="9.0059"
          y1="0.5106"
          x2="9.0059"
          y2="3.503"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="15.0063"
          y1="0.5106"
          x2="15.0063"
          y2="3.503"
        />
      </g>
    </svg>
  )
};

export default exported;

export const {
  menu,
  menuWhite,
  settings,
  tray,
  add,
  more,
  whiteAdd,
  x,
  info,
  print,
  email,
  documents,
  tick,
  taskTick,
  taskReset,
  cancel,
  customCancel,
  filter,
  notes,
  alert,
  filofax,
  lock,
  whiteLock,
  greenLock,
  down,
  up,
  save,
  go,
  back,
  person,
  star,
  openStar,
  location,
  providerCode,
  blankCalendar,
  arrowBackLeft,
  backCircle,
  backCircleWhite,
  nextCircle,
  nextCircleWhite,
  privacyOn,
  privacyOff,
  attachment,
  smsOn,
  smsOff,
  caretDown,
  graph,
  graph2,
  highlight,
  camera,
  cameraUpload,
  exitCircle,
  hamburgerMenu,
  heart,
  homeIcon,
  contactsIcon,
  diaryIcon,
  financesIcon,
  reportsIcon,
  prontoIcon,
  chat,
  edit
} = exported;
